/// <reference types="bun" />
import _clamp from "lodash-es/clamp";
export function clamp(value: number, min: number, max?: number) {
	return _clamp(value, min, max ?? value);
}
export function arrUserDifference<T extends { id: string; removed?: boolean | null }>(
	a: readonly T[],
	b: readonly T[]
) {
	const diff = b.filter((o) => !a.find((o2) => o.id === o2.id && o.removed === o2.removed));
	if (diff.length !== 0 || a.length !== b.length) return diff.map((x) => x.id);

	return null;
}
export function lazyProperty<T>(fn: () => Promise<T>): () => Promise<T> {
	const loaded = false;
	const store = new (class {
		value?: T;
	})();
	const storeProxy = new Proxy(store, {
		async get(target, _prop) {
			if (loaded) return async () => await Promise.resolve(target.value as T);
			return await fn().then((data) => (store.value = data));
		},
	});
	return async () => await (storeProxy.value as Promise<T>);
}
export function userIdCompare(first: string, secondCustomOrNorm: string) {
	return first === secondCustomOrNorm;
}
const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
export function isUUID(uuid: string) {
	return uuidRegex.test(String(uuid));
}
export const guestUuidPrefix = "00000000";
export function createGuestUuid() {
	return guestUuidPrefix + createUuid().slice(8);
}
export function isGuestUuid(uuid?: string | null): boolean {
	return typeof uuid === "string" && uuid.startsWith(`${guestUuidPrefix}-`);
}
export function createUuid(): string {
	return Bun.randomUUIDv7();
}
export function emailsEqual(a?: string | null, b?: string | null): boolean {
	return !!a && !!b && a.trim().toLowerCase() === b.trim().toLowerCase();
}
export function graphUserId(user: { id: string; mId?: string | null }): string {
	return user.mId || user.id;
}
export function isPendingInvite(user: { id?: string | null; invited?: boolean | null }): boolean {
	return user.invited === true || (!!user.id && isGuestUuid(user.id));
}
export function findWorkspaceUser<T extends { id: string; email?: string | null }>(
	users: readonly T[] | null | undefined,
	match: { id?: string | null; email?: string | null }
): T | undefined {
	if (!users?.length) return;
	if (match.id) {
		const byId = users.find((user) => user.id === match.id);
		if (byId) return byId;
	}
	if (match.email) return users.find((user) => emailsEqual(user.email, match.email));
}
export function isInvalidUuid(id?: string | null): boolean {
	return !id || id.startsWith("custom-") || !isUUID(id);
}
